<template>
  <div>
    <div v-if="tournament && tournament.flights && tournament.flights.length>0">
      <!-- The flight listings -->
      <div class="scrollable" v-for="flight in tournament.flights" :key="flight.id">
        <FlightDiagram :flight="flight" :tournament="tournament"/>
        <p></p>
        <md-divider/>
        <p></p>
      </div>
    </div>
    <div v-else>
      <md-empty-state
        md-icon="remove_circle"
        md-label="There are currently no flights for this tournament"
      ></md-empty-state>
    </div>
  </div>
</template>

<script>
import FlightDiagram from "./flightDiagram.vue";

export default {
  name: "TournamentFlights",
  components: {
    FlightDiagram
  },
  props: { tournament: Object },
  data: function() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.scrollable {
  overflow: auto;
  width: 100%;
  flex-wrap: nowrap;
}
</style>


// WEBPACK FOOTER //
// tournamentFlights.vue?48ad3f0a